import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';

export const STATUS_LABELS = {
  WAITING: 'ยังไม่เริ่ม',
  IN_PROGRESS: 'กำลังทำ',
  ON_HOLD: 'ส่งเสนอราคาลูกค้า',
  WON: 'ได้งาน',
  LOST: 'ไม่ได้งาน',
  CANCELLED: 'ยกเลิก',
};

export const STATUS_COLORS = {
  WAITING: 'default',
  IN_PROGRESS: 'info',
  ON_HOLD: 'warning',
  WON: 'success',
  LOST: 'error',
  CANCELLED: 'secondary',
};

// สีจริงต่อสถานะ (hex) — ใช้แทน STATUS_COLORS (MUI keyword) ทุกจุดที่ต้องโชว์สีสถานะ ให้สีตรงกัน
// เป๊ะทั้งโมดูล (ตาราง/ปฏิทิน/ตัวกรอง/การ์ด/ฯลฯ) MUI color=... ของ Chip/Icon รับได้แค่ keyword จาก
// theme.palette เท่านั้น (default/primary/secondary/error/info/success/warning) ไม่ยืดหยุ่นพอจะ
// กำหนด hex เองต่อสถานะแบบนี้ — จุดที่ต้องโชว์สีสถานะให้ใช้ getStatusHex/getStatusChipSx แทนการส่ง
// STATUS_COLORS[status] เข้า prop color ตรงๆ
export const STATUS_HEX_COLORS = {
  WAITING: '#9e9e9e',
  IN_PROGRESS: '#3b82f6',
  ON_HOLD: '#c9bf03',
  WON: '#10b981',
  LOST: '#ff0022',
  CANCELLED: '#ff7b00',
};

export function getStatusHex(status) {
  return STATUS_HEX_COLORS[status] || STATUS_HEX_COLORS.WAITING;
}

// sx สำเร็จรูปสำหรับ Chip สถานะ — filled = ตัวอักษรขาวพื้นสีสถานะ, outlined = ตัวอักษร/กรอบ/ไอคอน
// เป็นสีสถานะ พื้นหลังโปร่งใส (ของเดิมพึ่ง Chip color={STATUS_COLORS[status]} ซึ่งเพี้ยนจากสีจริงที่
// ต้องการเพราะเป็นแค่ keyword เทียบเคียง ไม่ใช่ hex ที่กำหนดเอง)
export function getStatusChipSx(status, variant = 'outlined') {
  const hex = getStatusHex(status);
  if (variant === 'filled') {
    return {
      bgcolor: hex,
      color: '#fff',
      '& .MuiChip-icon': { color: '#fff' },
    };
  }
  return {
    color: hex,
    borderColor: hex,
    '& .MuiChip-icon': { color: hex },
  };
}

// ไอคอนนำหน้า label — ใช้ร่วมกันทั้ง status chip ในตาราง, quick-filter chip ใน
// OpportunityFilters.js, และที่อื่นที่โชว์สถานะเป็น chip เพื่อให้ไอคอนต่อสถานะตรงกันทุกจุด
export const STATUS_ICONS = {
  WAITING: HourglassEmptyOutlinedIcon,
  IN_PROGRESS: AutorenewOutlinedIcon,
  ON_HOLD: SendOutlinedIcon,
  WON: CheckCircleOutlinedIcon,
  LOST: CancelOutlinedIcon,
  CANCELLED: BlockOutlinedIcon,
};

export const STATUS_OPTIONS = Object.keys(STATUS_LABELS);

// สถานะที่เลือกได้ตอนสร้างโครงการใหม่ (ไม่รวม WON/LOST/CANCELLED — ต้องผ่านปุ่ม
// "จบงาน"/"ยกเลิกโครงการ" แยกต่างหาก) — ดู CREATE_TIME_STATUSES ฝั่ง opportunity.controller.js
export const CREATE_TIME_STATUS_OPTIONS = ['WAITING', 'IN_PROGRESS', 'ON_HOLD'];

// สถานะที่เลือกได้อิสระจาก dropdown เปลี่ยนสถานะในหน้ารายละเอียด/ตาราง — เดิมแยกตาม
// is_tender (SENT_TO_CUSTOMER/AWAITING_TENDER_RESULT) แต่ตอนนี้รวมเป็นชุดเดียว (ON_HOLD)
// เพราะฟอร์มสร้างโครงการไม่มีตัวเลือกงานประมูลให้ตั้งแล้ว — คง param isTender ไว้เผื่อ
// caller เดิมยังส่งมา (ไม่ใช้แล้ว) ไม่ต้องแก้ signature ทุกจุดที่เรียก
export function getSelectableStatuses(isTender, currentStatus) {
  const base = ['WAITING', 'IN_PROGRESS', 'ON_HOLD'];
  return currentStatus && !base.includes(currentStatus)
    ? [...base, currentStatus]
    : base;
}
